import {useEffect} from "react";
import {useAsyncLocalStorage} from "../Auth/AuthProvider/useAsyncLocalStorage";
import {LocalStorageNames} from "../constants";
import useRelativeRouter from "../Navigation/useRelativeRouter/useRelativeRouter";
import useAuth from "../Auth/hooks/useAuth";

export const useMarketingConsent = () => {
    const {push} = useRelativeRouter();
    const {user} = useAuth();
    const {value, setValue} = useAsyncLocalStorage(
        LocalStorageNames.MARKETING_CONSENT_REDIRECT_URL,
        undefined,
    );

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const redirectUrl = params.get("redirectUrl");
        if (value && user) {
            push(`/u/t/${value}`);
            setValue(undefined);
            return;
        }
        if (redirectUrl) {
            setValue(redirectUrl);
        }
    }, [setValue, value, push, user]);
};
